import {Container, Text, VStack} from '@chakra-ui/layout';

import {useTranslate} from '@eksab/i18n';

export function Landing() {
  const t = useTranslate();

  return (
    <Container as="section" minH="100vh" w="100vw" maxW="100vw" bg="black" display="flex" alignItems="center" p={0}>
      <VStack spacing={6} align="center" w="100%" textAlign="center">
        <Text
          as="h1"
          fontFamily="Mont, Sans-serif"
          fontSize={['5xl', '5xl', '6xl', '8xl']}
          fontWeight="900"
          color="white"
        >
          {t('home.landing.heading')}
        </Text>
        <Text
          fontFamily="Garet, Sans-serif"
          fontSize="l"
          fontWeight="400"
          color="#5ac57b"
          textTransform={'uppercase'}
          letterSpacing="0.2rem"
        >
          {t('home.landing.subheading')}
        </Text>
        <Text
          fontFamily="Garet, Sans-serif"
          fontSize="3xl"
          lineHeight="10"
          fontWeight="400"
          color="#5ac57b"
          textTransform={'uppercase'}
          letterSpacing="0.2rem"
        >
          {t('home.landing.description', {
            br: () => <br />,
          })}
        </Text>
        <Text
          fontFamily="Garet, Sans-serif"
          fontSize="l"
          fontWeight="400"
          color="#5ac57b"
          textTransform={'uppercase'}
          letterSpacing="0.2rem"
        >
          {t('home.landing.launching-soon')}
        </Text>
      </VStack>
    </Container>
  );
}
